import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// swiper bundle styles
import "swiper/swiper-bundle.min.css";

// swiper core styles
import "swiper/swiper.min.css";

// modules styles
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";

import SwiperCore, { Navigation } from "swiper";

// install Swiper modules
SwiperCore.use([Navigation]);

export default function ImageSlider({
    imgSrcList,
    width,
    slidesPerView = 1,
    slideWidth = 200,
    slideHeight = 200,
}) {
    return (
        <Swiper
            navigation={true}
            slidesPerView={slidesPerView}
            style={{ width, "--swiper-navigation-color": "#fff" }}
        >
            {imgSrcList &&
                imgSrcList.length > 0 &&
                imgSrcList.map((src, idx) => (
                    <SwiperSlide key={idx}>
                        {src ? (
                            <div
                                style={{
                                    height: slideHeight,
                                    width: slideWidth,
                                    // background: "#8c8c8c",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <img
                                    src={src.image_src}
                                    style={{
                                        width: "auto",
                                        height: "100%",
                                        overflow: "hidden",
                                    }}
                                />
                            </div>
                        ) : (
                            <div
                                style={{
                                    height: slideHeight,
                                    width: slideWidth,
                                    // background: "#8c8c8c",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <span
                                    style={{
                                        // color: "white",
                                        color: "#8c8c8c",
                                        fontSize: 11,
                                    }}
                                >
                                    IMAGE
                                </span>
                            </div>
                        )}
                    </SwiperSlide>
                ))}
        </Swiper>
    );
}
